<script>
    import { Input, FormItem } from 'element-ui';
    import Vue from 'vue';

    Vue.use(Input);
    Vue.use(FormItem);

    export default {
        name: "toggle-password-input",

        props: {
            inputType: {
                type: String,
                default: 'password'
            },

            propName: {
                type: String,
                default: 'passwordInput'
            },

            labelName: {
                type: String,
                default: 'Current Password'
            },

            maxLength: {
                type: String,
                default: '255'
            },

            value: {
                type: String
            }
        },

        data() {
            return {
                hidePassword: true
            }
        },

        computed: {
            passwordType() {
                return this.hidePassword ? 'password' : 'text';
            },

            passwordIcon() {
                return this.hidePassword ? 'fa-eye' : 'fa-eye-slash';
            }
        },

        methods: {
            toggleVisibility() {
                this.hidePassword = ! this.hidePassword;
            }
        },
    }
</script>

<template>
    <div>
        <el-form-item
            :prop="propName"
            :label="labelName"
            :maxlength="maxLength">
            <el-input
                :ref="propName"
                :type="passwordType"
                :value="value"
                @input="$emit('input', $event)">
                <template slot="append">
                    <i  class="password-toggle fa"
                        :class="passwordIcon"
                        aria-hidden="true"
                        @click="toggleVisibility">
                    </i>
                </template>
            </el-input>
        </el-form-item>
    </div>
</template>
